import { render, staticRenderFns } from "./AttendancePieChart.vue?vue&type=template&id=8b2e2134&"
import script from "./AttendancePieChart.vue?vue&type=script&lang=js&"
export * from "./AttendancePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports